import React from 'react';
import { useNavigate } from 'react-router-dom';

import styles from '../Styles/Header.module.css';

const Header = ({ formInfo }) => {
  const navigate = useNavigate();


  return (
  <>
    <div className={styles.header}>
      <div className={styles.headerInner}>
        <img onClick={() => {navigate('/');}} className={styles.logo} src='/img/logo/logo-taksahouse2.png' alt='TaksaHouse' />
      </div>
      <div className={styles.headerInner}>
        <a className={styles.phoneNumberA}>{formInfo?.address}</a>
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'end'}}>
          <a className={styles.phoneNumberA} href={`tel:${formInfo?.phone_number}`}>{formInfo?.phone_number}</a>
          {formInfo?.phone_number_additional && <a className={styles.phoneNumberA} href={`tel:${formInfo?.phone_number_additional}`}>{formInfo?.phone_number_additional}</a>}
        </div>
      </div>
    </div>
  </>
  )
}

export default Header;